import { Icon } from "semantic-ui-react";

import "components/Notes/NoteTypeIcon/NoteTypeIcon.scss";
import { APPOINTMENT_NOTE_TYPES } from "models";

import type { CAR_NOTE_TYPE } from "models";

type NoteTypeIconProps = {
  type?: APPOINTMENT_NOTE_TYPES | CAR_NOTE_TYPE | null;
};

type NoteTypeConfig = { className?: string; text?: string; color: string };

const NOTE_TYPE_CONFIG: Record<number, NoteTypeConfig | undefined> = {
  [APPOINTMENT_NOTE_TYPES.Info]: { className: "info appointment-note-info-type-icon", color: "#2185D0" },
  [APPOINTMENT_NOTE_TYPES.BackOrder]: { text: "BO", className: "appointment-note-type-icon", color: "#6C0699" },
  [APPOINTMENT_NOTE_TYPES.NoDrive]: { className: "circle minus appointment-note-type-icon", color: "#FF0301" },
  [APPOINTMENT_NOTE_TYPES.MakeAnOffer]: { className: "dollar sign appointment-note-type-icon", color: "#000000" },
  [APPOINTMENT_NOTE_TYPES.WO]: { className: "file alt appointment-note-type-icon", color: "#2185D0" },
  [APPOINTMENT_NOTE_TYPES.Main]: { className: "sticky note appointment-note-type-icon", color: "#FF0202" },
  [APPOINTMENT_NOTE_TYPES.CallCustomer]: { className: "phone alt appointment-note-type-icon", color: "#21BA45" },
  [APPOINTMENT_NOTE_TYPES.Bill]: { className: "file invoice dollar appointment-note-type-icon", color: "#46B046" },
  [APPOINTMENT_NOTE_TYPES.Tyrescanner]: { className: "tile", color: "#FF8800" },
  [APPOINTMENT_NOTE_TYPES.TempDriver]: { className: "steering wheel appointment-note-type-icon", color: "#5C5C5C" },
  [APPOINTMENT_NOTE_TYPES.RecurringCar]: { className: "exclamation triangle appointment-note-type-icon", color: "#C83628" },
  [APPOINTMENT_NOTE_TYPES.Attachment]: { className: "paperclip appointment-note-type-icon", color: "#21A1D0" },
  [APPOINTMENT_NOTE_TYPES.ParkingLocation]: { className: "square parking appointment-note-type-icon", color: "#21A1D0" }
};

export const NoteTypeIcon = ({ type }: NoteTypeIconProps) => {
  if (!type) return null;

  const config = NOTE_TYPE_CONFIG[type];
  if (!config) return null;

  if (config.text)
    return (
      <span className={config.className} style={{ color: config.color }}>
        {config.text}
      </span>
    );

  return <Icon className={config.className} style={{ color: config.color }} />;
};
